import { Box, Card, DialogActions, Grid, Typography } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import FichaRepresentante from "../gestRepresentantes/fichaRepresentante";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import EmpresaEdit from "../dadosGenericos/empresaEdit";
import { useState } from "react";
import ImagemEdit from "../../utils/imagemEdit";
import Delete from "../../utils/delete";
import ChangeRepresentante from "./changeRepresentante";
import ButtonEditar from "../../utils/ButtonEditar";

export default function FichaEmpresa({ empresa, header, setRefresh, local }) {
    const [editDados, setEditDados] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [dadosEmpresa, setDadosEmpresa] = useState(empresa)
    const [openEditLogo, setOpenEditLogo] = useState(false);
    const [open, setOpen] = useState(false);
    const [changeRepresentante, setChangeRepresentante] = useState(false);
    // console.log(empresa)

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );
    
    return (
        <>
            {empresa ?
                <>
                    <Card style={{ padding: 20, minHeight: '20vh', marginBottom: 20, marginTop: 20 }}>
                        {messageSuccess && <MessageSuccess message={messageSuccess} />}
                        {messageError && <MessageError message={messageError} />}

                        <Delete
                            open={open}
                            setOpen={setOpen}
                            id={empresa?._id}
                            tipo={'Empresa'}
                            url={'/empresa/delete'}
                            msg={`Tem certeza que deseja eliminar a Empresa ${empresa?.nome}`}
                        />

                        <ChangeRepresentante
                            empresa={empresa}
                            open={changeRepresentante}
                            setOpen={setChangeRepresentante}
                        />

                        {header &&
                            <HeaderGestorConfigs
                                menu={true}
                                title={editDados ? 'EDITAR DADOS' : 'FICHA DA EMPRESA'}
                                configArea={'dadosempresa'}
                                empresa={empresa}
                                editDados={editDados}
                                setEditDados={setEditDados}
                                setChangeRepresentante={setChangeRepresentante}
                                delete={setOpen}
                            />
                        }

                        {!editDados ?
                            <>
                                {/* <DialogActions>
                                    <ButtonEditar setEdit={setEditDados} />
                                </DialogActions> */}

                                <Grid container>
                                    <Grid item marginRight={2}>
                                        <ImagemEdit
                                            data={empresa}
                                            url={'/empresa/change-logo'}
                                            local={'empresaId'}
                                            openEditLogo={openEditLogo}
                                            setOpenEditLogo={setOpenEditLogo}
                                        />
                                    </Grid>

                                    <Grid xs item>
                                        <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                                            <Grid container spacing={2}>
                                                {/* {renderField('Estado', empresa.status)} */}
                                                {renderField('Nome', empresa.nome)}
                                                {renderField('NIF', empresa.nif)}
                                                {renderField('Representante', empresa?.representante?.dadosPessoais?.nome)}
                                                {renderField('E-mail', empresa.email)}
                                                {renderField('Telefone1', empresa.tel1)}
                                                {renderField('Telefone2', empresa.tel2)}
                                                {renderField('Provincia', dadosEmpresa.provincia)}
                                                {renderField('Município', dadosEmpresa.municipio)}
                                                {renderField('Bairro', empresa.bairro)}
                                                {renderField('Rua / Avenida', empresa.rua)}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </>
                            :
                            <EmpresaEdit
                                dadosEmpresa={empresa}
                                setDadosEmpresa={setDadosEmpresa}
                                cancelEditDados={setEditDados}
                                setMessageSuccess={setMessageSuccess}
                                setMessageError={setMessageError}
                                setRefresh={setRefresh}
                            />
                        }
                    </Card>

                    {/* EXIBIR FICHA DO REPRESENTANTE JUNTAMENTE COM A FICHA DA EMPRESA */}
                    {(local === 'gestEmpresa' || local === 'analiseSolicitacao') &&
                        <FichaRepresentante header={header} representante={empresa?.representante} setRefresh={setRefresh} />
                    }
                </>
                :
                <Loading />
            }
        </>
    )
}